import React, { memo, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Container, Typo, Buttons, useOnScreen } from 'tmt-ui-kit';
import { useSelector } from 'react-redux';

import Colors from '~/utils/colors';
import config from '~/config';

const CustomizeBoxContainer = styled(Container.InnerContainer)`
  position: relative;
  display: flex;
  align-items: center;
  height: 280px;
  padding-left: 40px;
  border-radius: 6px;
  background-color: ${Colors.blueGrayLight};
  background-size: 505px;
  background-repeat: no-repeat;
  background-position: right bottom;

  @media only screen and (max-width: 1000px) {
    height: 280px;
    padding-right: 40px;
    &:before {
      top: 0;
      left: 0;
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(60deg, #f9fbfc, rgba(240, 245, 247, 0));
    }
  }
  @media only screen and (max-width: 610px) {
    padding-left: 16px;
    padding-right: 16px;
    &:before {
      background-image: linear-gradient(135deg, rgba(249,251,252,1) 0%,rgba(249,251,252,1) 10%,rgba(249,251,252,0.8) 56%,rgba(249,251,252,0) 100%);;
    }
  }
`;

const Title = styled(Typo.HeaderTwo)`
  font-weight: 600 !important;
  @media only screen and (max-width: 415px) {
    font-size: 14px;
  }
`;

const ContentContainer = styled.div`
  z-index: 1;
`;

const Content = styled(Typo.Paragraph)`
  margin-bottom: 30px;
  font-size: 16px !important;
  color: ${props => props.theme.black} !important;
  font-weight: normal !important;
  width: 65%;

  @media only screen and (max-width: 1000px) {
    width: 80%; 
  }
  @media only screen and (max-width: 576px) {
    font-size: 14px !important;  
  }
  @media only screen and (max-width: 470px) {
    width: 90%;  
  }
`;

const LearnMoreButton = styled(Buttons.Button.BlueButton)`
  margin: 0px;
  margin-bottom: 24px;
  width: 144px;
  width: 150px;
  font-weight: normal !important;  
`;

const CustomizeBox = props => {
  const { baseURL = config.baseURL.en, className = '' } = props;
  const containerRef = useRef(null);
  const isSeen = useOnScreen(containerRef);
  const affId = useSelector(state => state.app.affid);
  const isTGTHAffiliate = affId === config.tgthAffiliateId;
  if (isTGTHAffiliate) return null;
  useEffect(() => {
    if (isSeen) {
      containerRef.current.style.backgroundImage = `url('${config.assetPath}/static/images/TripDetail/request-trip.jpg')`;
    }
  }, [isSeen]);
  return (
    <a href={`${baseURL}/customize`} className={className}>
      <CustomizeBoxContainer ref={containerRef} style={{ backgroundColor: 'linear-gradient(59deg, #f9fbfc, rgba(240, 245, 247, 0))' }} >
        <ContentContainer>
          <Title>Not Exactly What You’re Looking For?</Title>
          <Content>Customize existing trips the way you want or even tell us where you want to go! We’ll find a Local Expert to take you there.</Content>
          <LearnMoreButton>Send Request</LearnMoreButton>
        </ContentContainer>
      </CustomizeBoxContainer>
    </a>
  );
};

export default memo(CustomizeBox, () => true);
